import React from "react";
import { motion } from "framer-motion";
import { facilities } from "../Data";
import facilityImage from "../Images/our-tradition.webp";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 35,
    scale: 0.96,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const imageVariant = {
  hidden: {
    opacity: 0,
    scale: 1.08,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.8,
      ease: "easeOut",
    },
  },
};


const Facilities = () => {
  return (
    <section className="facilities-section">
      <div className="container">
        <motion.p
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Our Facilities
        </motion.p>

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Rooted in Tradition. Driven by Excellence.
        </motion.h2>

        <div className="facilities-content">
          <motion.div
            className="facilities-layout"
            variants={containerVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.15,
            }}
          >
            {facilities.map((item, index) => (
              <motion.div
                key={index}
                className={`facility-card ${
                  index < 6
                    ? "three-col-card"
                    : "two-col-card"
                }`}
                variants={cardVariant}
                whileHover={{
                  y: -5,
                }}
                transition={{
                  duration: 0.4,
                }}
              >
                <motion.div
                  className="facility-icon"
                >
                  <img
                    src={item.icon}
                    alt={`${item.desc} | Dr. Jigar Gor's Ayurveda`}
                  />
                </motion.div>

                <p className="section-text">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* IMAGE */}

      <motion.div
        className="facilities-image"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={imageVariant}
      >
        <motion.img
          src={facilityImage}
          alt="Rooted in Tradition. Driven By Excellence | Dr. Jigar Gor's Ayurveda"
          whileHover={{
            scale: 1.03,
          }}
          transition={{
            duration: 0.8,
          }}
        />
      </motion.div>
    </section>
  );
};

export default Facilities;